module.exports = __webpack_public_path__ + "static/media/infoIcon.5ef7d8eb.svg";